import { useEffect, useState } from "react";
import axios, { cookies, MEDIA_BASE_URL } from "../axios/axios";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
const ColorCorrectionForm = () => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);

  const [errorMessage, setErrorMessage] = useState("");
  const [file, setFile] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addCulling, setAddCulling] = useState(false);
  const [cullingData, setCullingData] = useState({
    quantity: "1",
    culling_percentage: "",
  });

  const { id } = useParams();

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get("/services/getServices");
        setServices(response.data.services);
      } catch (error) {
        setErrorMessage(error.response?.data?.message || "An error occurred");
        toast.error(error.response?.data?.message || "An error occurred");
      }
    };
    fetchServices();
  }, []);

  const newData = services.find(
    (val) => val.id.replaceAll(" ", "-").replaceAll("/", "_") === id
  );

  const [data, setData] = useState({
    price: "",
    unit_price: "",
    order_name: "",
    cropping_straightening: "",
    type_of_shoot: "",
    Image_type: "",
    white_balance: "",
    noise_reduction: "",
    lens_correction: "",
    black_and_white: "",
    black_white_percentage: "",
    sample_for_review: "",
    quantity: "",
    social_media: "",
    drive_link: "",
    additional_notes: "",
    output_format: "",
  });

  useEffect(() => {
    if (newData) {
      // default quantity to 1 for better UX
      setData((prevData) => ({
        ...prevData,
        price: Number(newData.price),
        unit_price: Number(newData.price),
        quantity: prevData.quantity || "1",
      }));
    }
  }, [newData]);

  const getQuantity = () => Number(data.quantity) || 0;

  const dataHandler = (e) => {
    const { name, value } = e.target;

    if (name === "quantity") {
      // ensure integer >= 1
      const qty = Math.max(0, Math.floor(Number(value) || 0));

      setData((prevData) => {
        const unit = Number(prevData.unit_price) || 0;
        const newPrice =
          isCouponApplied && discount
            ? Number((unit * qty * (1 - discount / 100)).toFixed(2))
            : Number((unit * qty).toFixed(2));
        return { ...prevData, quantity: qty.toString(), price: newPrice };
      });

      // If files already selected, enforce count
      if (file && file.length > 0) {
        const selectedCount = file.length;
        if (qty === 1 && selectedCount > 1) {
          setFile([file[0]]);
          toast.info("Quantity set to 1 — extra selected files were removed.");
        } else if (qty > 0 && selectedCount > qty) {
          setFile(file.slice(0, qty));
          toast.info(
            `Quantity set to ${qty} — extra selected files were removed.`
          );
        }
      }
    } else if (name === "black_and_white") {
      setData((prevData) => ({
        ...prevData,
        black_and_white: value,
        black_white_percentage:
          value === "no" ? "" : prevData.black_white_percentage,
      }));
    } else {
      setData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const applyCoupon = async () => {
    try {
      const storedUser = cookies.get("user");
      console.log("storedUser from cookies:", storedUser);

      const userId = storedUser?.user?.id || null;

      if (!userId) {
        toast.error("User not found. Please log in again.");
        return;
      }

      const response = await axios.post("/coupon/validate", {
        code: couponCode,
        userId,
      });

      if (response.data.valid) {
        const qty = getQuantity() || 1;
        setDiscount(response.data.discount);
        setIsCouponApplied(true);

        // apply discount to total price (unit_price * qty)
        setData((prevData) => {
          const unit = Number(prevData.unit_price) || 0;
          const base = unit * qty;
          const newPrice = Number(
            (base * (1 - response.data.discount / 100)).toFixed(2)
          );
          return { ...prevData, price: newPrice };
        });

        toast.success("Coupon applied!");
      } else {
        setErrorMessage(response.data.message || "Coupon not valid");
        toast.error(response.data.message || "Coupon not valid");
      }
    } catch (error) {
      console.error("Error applying coupon:", error);
      setErrorMessage(
        error.response?.data?.message || "Error validating coupon."
      );
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  const dataSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...data,
        price: finalTotal,
        ...(addCulling && {
          culling: {
            quantity: cullingQty,
            culling_percentage: cullingData.culling_percentage,
          },
        }),
      };
      const { data: resData } = await axios.post(
        `/color-correction/${id}`,
        payload
      );

      toast.success("Data Submitted successfully!");
      navigate(`/upload-files/${resData.id}?type=color-correction`);
    } catch (error) {
      console.log(error);
      setErrorMessage(error.response?.data?.message || "An error occurred");
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  if (!newData) {
    return <h2 className="text-center my-5">Loading ...</h2>;
  }

  // helper to check if user selected exact number of files
  const isFileCountValid = () => {
    const qty = getQuantity();
    if (qty === 0) return true; // no restriction
    return file && file.length === qty;
  };

  const cullingService = services.find((val) => val.service === "Culling");
  const cullingUnitPrice = Number(cullingService?.price) || 0;
  const cullingQty = Math.max(0, Number(cullingData.quantity) || 0);
  const cullingSubtotal = addCulling ? cullingUnitPrice * cullingQty : 0;

  const qty = getQuantity();
  const originalTotal =
    Number(data.unit_price || 0) * (qty || 1) + cullingSubtotal;
  // Coupon discount only applies to the base color-correction price; the
  // culling add-on is added on top at full price.
  const finalTotal = Number(data.price || 0) + cullingSubtotal;

  return (
    <>
      <Navbar />
      <div className="mx-5">
        <ToastContainer position="top-right" autoClose={5000} theme="colored" />
        <div className="row align-items-center py-5">
          <div className="col-md-6 my-4">
            <img
              className="w-100 object-fit-cover"
              height={600}
              src={`${MEDIA_BASE_URL}/${newData.image}`}
              crossOrigin="anonymous"
              alt="Color Correction"
            />
          </div>

          <div className="col-md-6 my-4 ps-5">
            <h4 className="mb-3">{newData.title}</h4>
            <h5 className="mb-3">
              Price:{" "}
              {isCouponApplied ? (
                <>
                  <del className="text-danger me-2">
                    ${originalTotal.toFixed(2)}
                  </del>
                  <span className="text-success">
                    ${finalTotal.toFixed(2)}
                  </span>
                </>
              ) : (
                <span className="text-dark">${originalTotal.toFixed(2)}</span>
              )}
            </h5>

            <div className="row g-3 align-items-center mb-1">
              <div className="col-md-4">
                <label className="fs-14 col-form-label">Coupon Code</label>
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control shadow-none rounded-2 p-2"
                  placeholder="Enter Coupon"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                  disabled={isCouponApplied}
                />
              </div>
              <button
                className="col-md-2 btn py-2 px-0 rounded-2 btn-secondary mt-2"
                onClick={applyCoupon}
                disabled={isCouponApplied}
              >
                Apply
              </button>
            </div>

            <form onSubmit={dataSubmit}>
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label htmlFor="order_name" className="fs-14 col-form-label">
                    Order Name
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    onChange={dataHandler}
                    type="text"
                    name="order_name"
                    value={data.order_name}
                    className="form-control shadow-none rounded-2 p-2"
                    required
                  />
                </div>
              </div>
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label className="fs-14 col-form-label">
                    Cropping Straightening
                  </label>
                </div>
                <div className="col-md-8">
                  <select
                    onChange={dataHandler}
                    name="cropping_straightening"
                    value={data.cropping_straightening}
                    className="w-100 p-2 form-control"
                  >
                    <option value="">Select</option>
                    <option value="No Cropping & Straightening">
                      No Cropping & Straightening
                    </option>
                    <option value="Loose Cropping & Straightening">
                      Loose Cropping & Straightening
                    </option>
                    <option value="Close Cropping & Straightening">
                      Close Cropping & Straightening
                    </option>
                    <option value="No Cropping Only Straightening">
                      No Cropping Only Straightening
                    </option>
                  </select>
                </div>
              </div>
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label className="fs-14 col-form-label">Type of Shoot</label>
                </div>
                <div className="col-md-8">
                  <select
                    onChange={dataHandler}
                    name="type_of_shoot"
                    value={data.type_of_shoot}
                    className="w-100 p-2 form-control"
                  >
                    <option value="">Select</option>
                    <option value="Wedding">Wedding</option>
                    <option value="Studio">Studio</option>
                    <option value="Event">Event</option>
                    <option value="Baby">Baby</option>
                    <option value="School">School</option>
                    <option value="Seniors">Seniors</option>
                    <option value="Sports">Sports</option>
                    <option value="Lifestyle">Lifestyle</option>
                    <option value="Landscape">Landscape</option>
                  </select>
                </div>
              </div>
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label className="fs-14 col-form-label">Type of Image</label>
                </div>
                <div className="col-md-8">
                  <select
                    onChange={dataHandler}
                    name="Image_type"
                    value={data.Image_type}
                    className="w-100 p-2 form-control"
                  >
                    <option value="">Select</option>
                    <option value="RAW (DNG, CR2,NEF etc)">
                      RAW (DNG, CR2,NEF etc)
                    </option>
                    <option value="Lightroom 5 with Smart Previews">
                      Lightroom 5 with Smart Previews
                    </option>
                    <option value="Lightroom 6/CC with Smart Previews">
                      Lightroom 6/CC with Smart Previews
                    </option>
                    <option value="Lightroom Classic CC with Smart Previews">
                      Lightroom Classic CC with Smart Previews
                    </option>
                  </select>
                </div>
              </div>
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label className="fs-14 col-form-label">White Balance</label>
                </div>
                <div className="col-md-8">
                  <select
                    onChange={dataHandler}
                    name="white_balance"
                    value={data.white_balance}
                    className="w-100 p-2 form-control"
                  >
                    <option value="">Select</option>
                    <option value="cool">Cool</option>
                    <option value="neutral">Neutral</option>
                    <option value="warm">Warm</option>
                  </select>
                </div>
              </div>
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label className="fs-14 col-form-label">
                    Noise Reduction
                  </label>
                </div>
                <div className="col-md-8">
                  <select
                    onChange={dataHandler}
                    name="noise_reduction"
                    value={data.noise_reduction}
                    className="w-100 p-2 form-control"
                  >
                    <option value="">Select</option>
                    <option value="No ">No </option>
                    <option value="Yes - Apply 400 ISO and up">
                      Yes - Apply 400 ISO and up
                    </option>
                    <option value="Yes - Apply 800 ISO and up ">
                      Yes - Apply 800 ISO and up
                    </option>
                    <option value="Yes - Apply 1000 ISO and up ">
                      Yes - Apply 1000 ISO and up
                    </option>
                    <option value="Yes - Apply 1600 ISO and up ">
                      Yes - Apply 1600 ISO and up
                    </option>
                    <option value="Yes - Apply 3200 ISO and up ">
                      Yes - Apply 3200 ISO and up
                    </option>
                    <option value="Yes - Apply 6400 ISO and up ">
                      Yes - Apply 6400 ISO and up
                    </option>
                  </select>
                </div>
              </div>
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label className="fs-14 col-form-label">
                    Lens Correction
                  </label>
                </div>
                <div className="col-md-8">
                  <select
                    onChange={dataHandler}
                    name="lens_correction"
                    value={data.lens_correction}
                    className="w-100 p-2 form-control"
                  >
                    <option value="">Select</option>
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                    <option value="landscape">Landscape</option>
                  </select>
                </div>
              </div>
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label className="fs-14 col-form-label">Black & White</label>
                </div>
                <div className="col-md-8">
                  <select
                    onChange={dataHandler}
                    name="black_and_white"
                    value={data.black_and_white}
                    className="w-100 p-2 form-control"
                  >
                    <option value="">Select</option>
                    <option value="no">No</option>
                    <option value=" B&W Conversion (No corresponding color version)">
                      B&W Conversion (No corresponding color version)
                    </option>
                    <option value="B&W Copies(include B&W and color versions)">
                      B&W Copies(include B&W and color versions)
                    </option>
                  </select>
                </div>
              </div>
              {data.black_and_white !== "no" && (
                <div className="row g-3 align-items-center mb-1">
                  <div className="col-md-4">
                    <label className="fs-14 col-form-label">
                      Black & White Percentage
                    </label>
                  </div>
                  <div className="col-md-8">
                    <select
                      onChange={dataHandler}
                      name="black_white_percentage"
                      value={data.black_white_percentage}
                      className="w-100 p-2 form-control"
                    >
                      <option value="">Select</option>
                      <option value="10">10%</option>
                      <option value="20">20%</option>
                      <option value="10% only B&W and color">
                        10% only B&W and color
                      </option>
                      <option value="20% only B&W and color">
                        20% only B&W and color
                      </option>
                    </select>
                  </div>
                </div>
              )}
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label className="fs-14 col-form-label">
                    Need Sample for Review
                  </label>
                </div>
                <div className="col-md-8">
                  <select
                    onChange={dataHandler}
                    name="sample_for_review"
                    value={data.sample_for_review}
                    className="w-100 p-2 form-control"
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label className="fs-14 col-form-label">Output Format</label>
                </div>
                <div className="col-md-8">
                  <select
                    onChange={dataHandler}
                    name="output_format"
                    value={data.output_format}
                    className="w-100 p-2 form-control"
                  >
                    <option value="">Select</option>
                    <option value="JPEG Image">JPEG Image</option>
                    <option value="Catalog - Lightroom 5">
                      Catalog - Lightroom 5
                    </option>
                    <option value="Catalog - Lightroom 6/CC">
                      Catalog - Lightroom 6/CC
                    </option>
                    <option value="Catalog - Lightroom Classic">
                      Catalog - Lightroom Classic
                    </option>
                    <option value="Catalog - Lightroom 5 & XMPs">
                      Catalog - Lightroom 5 & XMPs
                    </option>
                    <option value="Catalog - Lightroom 6/CC & XMPs">
                      Catalog - Lightroom 6/CC & XMPs
                    </option>
                    <option value="Catalog - Lightroom Classic & XMPs">
                      Catalog - Lightroom Classic & XMPs
                    </option>
                  </select>
                </div>
              </div>
              <div class="row g-3 align-items-center mb-1">
                <div class="col-md-4">
                  <label for="inputPassword6" class="fs-14 col-form-label">
                    Social Media
                  </label>
                </div>
                <div class="col-md-8">
                  <select
                    onChange={dataHandler}
                    name="social_media"
                    value={data.social_media}
                    className="w-100 p-2 form-control"
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>{" "}
                </div>
              </div>
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label htmlFor="quantity" className="fs-14 col-form-label">
                    Quantity
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    onChange={dataHandler}
                    name="quantity"
                    value={data.quantity}
                    type="number"
                    min={1}
                    className="form-control shadow-none rounded-2 p-2"
                    required
                  />
                </div>
              </div>
              {/* <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label htmlFor="upload" className="fs-14 col-form-label">
                    Upload
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    type="file"
                    multiple={qty > 1}
                    accept="image/*"
                    onChange={onFileChange}
                    className="form-control shadow-none rounded-2"
                  />
                </div>
              </div>
              or
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label htmlFor="order_name" className="fs-14 col-form-label">
                    Paste Link
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    onChange={dataHandler}
                    placeholder="Google drive, Dropbox, WeTransfer Etc.."
                    type="text"
                    name="drive_link"
                    value={data.drive_link}
                    className="form-control shadow-none rounded-2 p-2"
                  />
                </div>
              </div> */}
              <div className="row g-3 align-items-center mb-1">
                <div className="col-md-4">
                  <label
                    htmlFor="additional_notes"
                    className="fs-14 col-form-label"
                  >
                    Additional Notes
                  </label>
                </div>
                <div className="col-md-8">
                  <textarea
                    onChange={dataHandler}
                    name="additional_notes"
                    value={data.additional_notes}
                    className="form-control shadow-none rounded-2 p-2"
                  ></textarea>
                </div>
              </div>
              {cullingService && (
                <div className="row g-3 align-items-center mb-1">
                  <div className="col-md-4">
                    <label className="fs-14 col-form-label">
                      Culling Service
                    </label>
                  </div>
                  <div className="col-md-8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={addCulling}
                      onChange={(e) => setAddCulling(e.target.checked)}
                    />
                  </div>
                </div>
              )}
              {cullingService && addCulling && (
                <>
                  <div className="row g-3 align-items-center mb-1">
                    <div className="col-md-4">
                      <label className="fs-14 col-form-label">Quantity</label>
                    </div>
                    <div className="col-md-8">
                      <input
                        type="number"
                        min={1}
                        className="form-control shadow-none rounded-2 p-2"
                        value={cullingData.quantity}
                        onChange={(e) => {
                          const nextQty = Math.max(
                            0,
                            Math.floor(Number(e.target.value) || 0)
                          );
                          setCullingData((prev) => ({
                            ...prev,
                            quantity: nextQty.toString(),
                          }));
                        }}
                        required
                      />
                    </div>
                  </div>
                  <div className="row g-3 align-items-center mb-1">
                    <div className="col-md-4">
                      <label className="fs-14 col-form-label">
                        Culling Percentage
                      </label>
                    </div>
                    <div className="col-md-8">
                      <select
                        className="w-100 p-2 form-control"
                        value={cullingData.culling_percentage}
                        onChange={(e) =>
                          setCullingData((prev) => ({
                            ...prev,
                            culling_percentage: e.target.value,
                          }))
                        }
                        required
                      >
                        <option value="">Select</option>
                        <option value="Upto 30%">Upto 30%</option>
                        <option value="31% to 50%">31% to 50%</option>
                        <option value="51% to 70%">51% to 70%</option>
                      </select>
                    </div>
                  </div>
                </>
              )}
              <button
                type="submit"
                className="btn bg_maincolor text-white"
                disabled={loading}
              >
                {loading ? "Loading..." : "Order Now"}
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ColorCorrectionForm;
